import { render, staticRenderFns } from "./GenerateKeywordsDialog.vue?vue&type=template&id=586df1a2"
import script from "./GenerateKeywordsDialog.vue?vue&type=script&lang=js"
export * from "./GenerateKeywordsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports